import { useEffect, useState, useRef } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { firestore } from "../../../firebase";
import Header from "./header"

export default function Billing({currentUser}) {
  const [rows, setRows] = useState([]);
  const [toEnd, setToEnd] = useState(false);
  const [loading, setLoading] = useState(false);
  const pageSize = 10;
  const [qs, setQs] = useState(null);
  const mountedRef = useRef(true);

  useEffect(()=>{
    if(currentUser.paymentType === "stripe") {
      getInvoices(currentUser.email, pageSize)
    }
  }, [])

  const getInvoices = (accountId, pageSize, lastDoc) => {
    setLoading(true);
    let records = [];
    const collectionRef = firestore
      .collection("accounts")
      .doc(accountId)
      .collection("invoices");
    let query = collectionRef.orderBy("created", "desc");
    query = query.limit(pageSize);
    query.get().then((documentSnapshots) => {
      
      if (!mountedRef.current) return null;
      if (documentSnapshots.empty) {
        setToEnd(true);
      } else {
        setRows([])
        documentSnapshots.forEach((doc) => {
          records.push({
            id: doc.id,
            total: Math.round(doc.data().total / 100).toFixed(2),
            subTotal: Math.round(doc.data().subTotal / 100).toFixed(2),
            tax: Math.round((doc.data().tax || 0) / 100).toFixed(2),
            amountPaid: Math.round(doc.data().amountPaid / 100).toFixed(2),
            created: new Date(doc.data().created * 1000).toLocaleString(),
            hostedInvoiceUrl: doc.data().hosted_invoice_url,
            currency: doc.data().currency,
            status: doc.data().status,
          });
        });
        if (records.length > 0) {
          setRows((rows) => rows.concat(records));
        }
      }
      setLoading(false);
    });
  };
  return (
    <div className="container-fluid">
    <Backdrop open={loading} style={{ zIndex: 10000 }}>
      <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
    </Backdrop>
      <div className="animated fadeIn">
        <Header currentUser={currentUser} />
        <div className="card">
          <div className="card-body">
            {rows.length > 0 && (
              <>
                <table className="table table-responsive-sm table-hover table-outline">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Invoice ID</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                      <th scope="col">Invoice Date</th>
                      <th scope="col">Invoice URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, i) => (
                      <tr key={r.id}>
                        <td>
                          <a
                            className="btn btn-link"
                            rel="noreferrer"
                            href={r.hostedInvoiceUrl}
                            target="_blank"
                          >
                            {r.id}
                          </a>
                        </td>
                        <td>
                          SGD
                          {r.total}
                        </td>
                        <td>{r.status.toUpperCase()}</td>
                        <td>{r.created}</td>
                        <td>
                          <a
                            href={r.hostedInvoiceUrl}
                            rel="noreferrer"
                            target="_blank"
                            className="btn btn-info"
                          >
                            View Invoice
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
            {toEnd && <span>End of all invoices</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
